module.exports = __webpack_public_path__ + "media/concept_material-330c2f2104b9b075a82554ac57158af9.svg";